import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

// For protecting routes that require authentication
export const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem('member_token');
  const memberData = localStorage.getItem('member_data');
  const tokenExpiry = localStorage.getItem('token_expiry');

  useEffect(() => {
    // Check token expiry on mount and every 30 seconds
    const checkExpiry = () => {
      if (token && tokenExpiry) {
        const now = Date.now();
        const expiryTime = parseInt(tokenExpiry, 10);
        
        if (now >= expiryTime) {
          // Token expired
          localStorage.removeItem('member_token');
          localStorage.removeItem('member_data');
          localStorage.removeItem('token_expiry');
          
          Swal.fire({
            icon: 'warning',
            title: 'Session Expired',
            text: 'Your 45-minute session has expired. Please login again.',
            timer: 3000,
            showConfirmButton: false,
          }).then(() => {
            navigate('/members/members-area', { replace: true });
          });
        }
      }
    };

    // Check immediately
    checkExpiry();
    
    // Set up interval to check every 30 seconds (less frequent for 45-minute session)
    const intervalId = setInterval(checkExpiry, 30000);
    
    return () => clearInterval(intervalId);
  }, [token, tokenExpiry, navigate]);

  // Simple check for initial render
  if (!token || !memberData || !tokenExpiry) {
    return <Navigate to="/members/members-area" replace />;
  }

  // Check if token is expired
  const now = Date.now();
  const expiryTime = parseInt(tokenExpiry, 10);
  
  if (now >= expiryTime) {
    return <Navigate to="/members/members-area" replace />;
  }

  return children;
};

// For protecting routes that should NOT be accessible when logged in
export const AuthRoute = ({ children }) => {
  const token = localStorage.getItem('member_token');
  const memberData = localStorage.getItem('member_data');
  const tokenExpiry = localStorage.getItem('token_expiry');

  // Check if token exists and is not expired
  if (token && memberData && tokenExpiry) {
    const now = Date.now();
    const expiryTime = parseInt(tokenExpiry, 10);
    
    if (now < expiryTime) {
      return <Navigate to="/members/members-dashboard" replace />;
    }
  }

  return children;
};